// extracted by mini-css-extract-plugin
export default {"scroll-to-top-button":"ScrollToTop_scroll-to-top-button__u219q","visible":"ScrollToTop_visible__qnavN","icon":"ScrollToTop_icon__uXBJg"};